import { render, staticRenderFns } from "./PatientTable.vue?vue&type=template&id=a5cc30aa&scoped=true"
import script from "./PatientTable.vue?vue&type=script&lang=ts"
export * from "./PatientTable.vue?vue&type=script&lang=ts"
import style0 from "./PatientTable.vue?vue&type=style&index=0&id=a5cc30aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc30aa",
  null
  
)

export default component.exports